class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/archive`;
    }
    /**
     * Returns the created report with message data not including attachments.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-report/{taskId}/archive
     * Rate Limit Group: Heavy
     * App Permission: ReadMessages
     * User Permission: Users
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
